module.exports = __webpack_public_path__ + "static/media/happy_face_gray.27adb723.svg";